import { useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

const post = (path, file) => { const fd = new FormData(); fd.append("file", file); return api.post(`/rrhh/import/${path}`, fd); };

const PreviewTable = ({ rows }) => (
  <div className="overflow-x-auto max-h-80 rounded-xl border"><table className="w-full text-xs">
    <thead className="bg-[#f7f9f5] sticky top-0"><tr>{["Fila", "RUT", "Nombre", "Cargo", "Contrato", "Centro de costo", "Acción", "Observaciones"].map((h) => <th key={h} className="px-2 py-1.5 text-left">{h}</th>)}</tr></thead>
    <tbody>{rows.map((r) => (
      <tr key={r.row} className={`border-t ${r.errors.length ? "bg-[#fdf1f0]" : ""}`} data-testid={`emp-import-row-${r.row}`}>
        <td className="px-2 py-1">{r.row}</td><td className="px-2 font-mono">{r.rut}</td><td className="px-2">{r.nombres} {r.apellidos}</td>
        <td className="px-2">{r.cargo}</td><td className="px-2">{r.contrato}</td><td className="px-2">{r.cc}</td><td className="px-2">{r.action}</td>
        <td className="px-2"><span className="text-[#b42318]">{r.errors.join("; ")}</span>{r.errors.length > 0 && r.warnings.length > 0 ? "; " : ""}<span className="text-[#8a5a00]">{r.warnings.join("; ")}</span></td></tr>))}</tbody>
  </table></div>
);

export const EmployeeImportDialog = ({ open, onOpenChange, onDone }) => {
  const [file, setFile] = useState(null);
  const [prev, setPrev] = useState(null);
  const [busy, setBusy] = useState(false);
  const preview = async (f) => {
    setFile(f); setPrev(null);
    if (!f) return;
    try { const { data } = await post("preview", f); setPrev(data); } catch (e) { toast.error(errMsg(e)); }
  };
  const commit = async () => {
    setBusy(true);
    try {
      const { data } = await post("commit", file);
      toast.success(`${data.created} fichas creadas, ${data.updated} actualizadas`);
      if (!data.sensitive_saved || !data.pay_saved) toast.warning("Su usuario no tiene permiso para guardar datos sensibles o remuneraciones: esos datos no se cargaron");
      setFile(null); setPrev(null); onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const close = (o) => { if (!o) { setFile(null); setPrev(null); } onOpenChange(o); };
  const valid = prev ? prev.create + prev.update : 0;
  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="max-w-5xl max-h-[92vh] overflow-y-auto" data-testid="emp-import-dialog">
        <DialogHeader><DialogTitle>Importar trabajadores desde planilla</DialogTitle></DialogHeader>
        <ol className="text-sm text-[#5b6656] list-decimal pl-5 space-y-1">
          <li>Suba la planilla de trabajadores (.xlsx) con columnas RUT, NOMBRES, APELLIDO PATERNO, CARGO, FECHA DE INGRESO, etc.</li>
          <li>Se toman datos personales, cargo, contrato, centro de costos, sueldo base, AFP, salud y banco (cifrados). Los "Finiquitado" no se importan.</li>
          <li>Si el RUT ya existe, la ficha se actualiza. Los cargos y centros de costo nuevos se crean solos. El área queda "Sin asignar".</li>
        </ol>
        <label className="inline-flex w-fit items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold cursor-pointer hover:bg-[#f6fbf2]"><Upload size={15} />{file ? file.name : "Subir Excel"}
          <input data-testid="emp-import-file-input" type="file" accept=".xlsx" className="hidden" onChange={(e) => { preview(e.target.files?.[0] || null); e.target.value = ""; }} /></label>
        {prev && <div data-testid="emp-import-preview">
          <div className="text-sm mb-2" data-testid="emp-import-summary"><b>{prev.total}</b> trabajadores · <span className="text-[#1c6e00]">{prev.create} nuevos</span> · {prev.update} a actualizar · <span className="text-[#b42318]">{prev.with_errors} con errores (no se importan)</span> · {prev.skipped_finiquitados} finiquitados omitidos</div>
          <PreviewTable rows={prev.rows} />
        </div>}
        <DialogFooter><Button data-testid="emp-import-commit-btn" className="rounded-full" disabled={!valid || busy} onClick={commit}>{busy ? "Importando…" : `Importar ${valid} trabajadores`}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
